import { boolean, pgEnum, pgTable, timestamp, varchar } from "drizzle-orm/pg-core";
export const fulfillmentCriterion = {
    QUANTITY: "quantity",
    NONE: "none",
};
export const targetQuantity = {
    FIXED: "fixed",
    FLEXIBLE: "flexible",
    NONE: "none",
};
// Bucket type keys - single source of truth for valid bucket types
// Adding new bucket types requires a DB migration, but provides database-level validation
export const bucketTypeKey = {
    FIX_FIX_NONE_NONE: "fix_fix_none_none",
    FIX_FLEX_NONE_NONE: "fix_flex_none_none",
    FLEX_FLEX_NONE_NONE: "flex_flex_none_none",
    FLEX_FIX_NONE_NONE: "flex_fix_none_none",
};
function enumToPgEnum(myEnum) {
    return Object.values(myEnum);
}
export const fulfillmentCriterionEnum = pgEnum("fulfillment_criterion", enumToPgEnum(fulfillmentCriterion));
export const targetQuantityEnum = pgEnum("target_quantity", enumToPgEnum(targetQuantity));
export const bucketTypeKeyEnum = pgEnum("bucket_type_key", enumToPgEnum(bucketTypeKey));
export const bucketTypes = pgTable("bucket_type", {
    // Key IS the primary key - no separate ID needed for lookup tables
    key: bucketTypeKeyEnum("key").primaryKey(),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .defaultNow()
        .notNull()
        .$onUpdate(() => new Date()),
    title: varchar("title", { length: 100 }).notNull(),
    description: varchar("description", { length: 350 }),
    fulfillmentCriterion: fulfillmentCriterionEnum("fulfillment_criterion").notNull(),
    startTimeFlexible: boolean("start_time_flexible").default(true),
    endTimeFlexible: boolean("end_time_flexible").default(true),
    targetQuantity: targetQuantityEnum("target_quantity").default("none"),
});
